/* eslint-disable no-useless-escape */
import dayjs from "dayjs";
import numeral from "numeral";
import { toJS } from "mobx";

// var userLang = navigator.language || navigator.userLanguage
// console.log('LANGUAGE: ' + userLang)

// if (Array.prototype.equals)
//   console.warn(
//     'Overriding existing Array.prototype.equals. Possible causes: New API defines the method, there\'s a framework conflict or you\'ve got double inclusions in your code.'
//   )
// // attach the .equals method to Array's prototype to call it on any array
// Array.prototype.equals = function(array) {
//   // if the other array is a falsy value, return
//   if (!array) return false

//   // compare lengths - can save a lot of time
//   if (this.length !== array.length) return false

//   for (var i = 0, l = this.length; i < l; i++) {
//     // Check if we have nested arrays
//     if (this[i] instanceof Array && array[i] instanceof Array) {
//       // recurse into the nested arrays
//       if (!this[i].equals(array[i])) return false
//     } else if (this[i] !== array[i]) {
//       // Warning - two different object instances will never be equal: {x:20} !== {x:20}
//       return false
//     }
//   }
//   return true
// }

var // ruleRegex = /^(.+?)\[(.+)\]$/,
  numericRegex = /^[0-9]+$/,
  integerRegex = /^\-?[0-9]+$/,
  decimalRegex = /^\-?[0-9]*\.?[0-9]+$/,
  emailRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
  alphaRegex = /^[a-z]+$/i,
  // alphaNumericRegex = /^[a-z0-9]+$/i,
  alphaDashRegex = /^[a-z0-9_\-]+$/i,
  naturalRegex = /^[0-9]+$/i,
  naturalNoZeroRegex = /^[1-9][0-9]*$/i,
  // ipRegex = /^((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){3}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})$/i,
  // base64Regex = /[^a-zA-Z0-9\/\+=]/i,
  // numericDashRegex = /^[\d\-\s]+$/,
  // urlRegex = /^((http|https):\/\/(\w+:{0,1}\w*@)?(\S+)|)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?$/,
  // dateRegex = /\d{4}-\d{1,2}-\d{1,2}/,
  timeRegex = /^\d{2,}:(?:[0-5]\d)$/;

class common {
  static getNextFourteenDays = () => {
    const periodStart = dayjs();
    const periodEnd = dayjs().add(14, "days");

    var days = [];
    var day = periodStart;
    var index = 0;

    while (day <= periodEnd) {
      days.push({
        index: index,
        dayValue: day.format("YYYY-MM-DD"),
        dayDisplay: day.format("ddd, Do MMM YY"),
      });
      day = day.clone().add(1, "d");
      index += 1;
    }
    return days;
  };

  static getDays = () => {
    var days = this.getNextFourteenDays();
    return days.map((day) => {
      return new Date(day.dayValue);
    });
  };

  static getDepots = (data) => {
    var unsortedDepots = data.reduce((depots, item) => {
      if (depots.indexOf(item._id.depotRef) === -1) depots.push(item._id.depotRef);
      return depots;
    }, []);
    return unsortedDepots.sort();
  };

  static getDepotStatistics = (depot, statistics, days) => {
    var depotData = new Array(days.length + 2);
    depotData.fill(["", "", "", "", ""], 1, days.length);
    depotData[0] = ["Jobs", "Service", "Delivery", "Collection", "Items"];
    depotData[days.length] = depotData[0];
    var jobs = 0,
      service = 0,
      delivery = 0,
      collection = 0,
      items = 0;
    statistics.forEach((current) => {
      var daypos = days.findIndex((day) => {
        var dt = new Date(current._id.scheduleDate);
        return dt.getTime() === day.getTime();
      });
      if (current._id.depotRef === depot.depotRef && daypos > -1) {
        jobs += current.jobs;
        service += current.service;
        delivery += current.delivery;
        collection += current.collection;
        items += current.items;
        depotData[daypos + 1] = [current.jobs, current.service, current.delivery, current.collection, current.items];
      }
    });
    depotData[days.length + 1] = [jobs, service, delivery, collection, items];
    return depotData;
  };

  static getTotalStatistics = (statistics, days) => {
    var depotData = new Array(days.length + 2);
    depotData.fill([0, 0, 0, 0, 0], 1, days.length);
    depotData[0] = ["Jobs", "Service", "Delivery", "Collection", "Items"];
    depotData[days.length] = depotData[0];
    var jobs = 0,
      service = 0,
      delivery = 0,
      collection = 0,
      items = 0;
    statistics.forEach((current) => {
      var daypos = days.findIndex((day) => {
        var dt = new Date(current._id.scheduleDate);
        return dt.getTime() === day.getTime();
      });
      if (daypos > -1) {
        jobs += current.jobs;
        service += current.service;
        delivery += current.delivery;
        collection += current.collection;
        items += current.items;
        depotData[daypos + 1] = [
          depotData[daypos + 1][0] + current.jobs,
          depotData[daypos + 1][1] + current.service,
          depotData[daypos + 1][2] + current.delivery,
          depotData[daypos + 1][3] + current.collection,
          depotData[daypos + 1][4] + current.items,
        ];
      }
    });
    depotData[days.length + 1] = [jobs, service, delivery, collection, items];
    return depotData;
  };

  static recursiveDeepCopy = (object, level) => {
    if (level === undefined) {
      level = 0;
    }
    level++;
    if (level > this.highestLevel) {
      this.highestLevel = level;
    }

    let newLevel = {};

    if (typeof object !== "object") {
      return object;
    }
    if (!object) {
      return object;
    }

    for (var key of Object.keys(object)) {
      let objValue = object[key];
      let objType = Object.prototype.toString.apply(objValue);

      // START TESTS
      if (key === "marker") {
        newLevel[key] = "marker: removed by recursiveDeepCopy to avoid circular reference";
        return newLevel;
      }
      if (key === "map") {
        newLevel[key] = "map: removed by recursiveDeepCopy to avoid circular reference";
        return newLevel;
      }
      /*
      if (key === 'mapClick') {
        newLevel[key] = 'mapClick: removed by recursiveDeepCopy to avoid circular reference'
        return newLevel
      }
      if (key === '__v') {
        newLevel[key] = '__v: removed by recursiveDeepCopy to avoid circular reference'
        return newLevel
      }

      if (key === '_v') {
        newLevel[key] = '_v: removed by recursiveDeepCopy to avoid circular reference'
        return newLevel
      }
      */
      // END TESTS

      // let space = '.'.repeat(level)

      if (String(objType) === "[object Object]") {
        // console.log('Type: ' + objType + ' | Property (' + level + ') | Key:' + key + ' = ' + objValue)
        try {
          if (String(objValue).indexOf("[mobx.array]") !== -1) {
            newLevel[key] = [];

            for (let objMobx of objValue) {
              newLevel[key].push(this.recursiveDeepCopy(objMobx, level));
            }
          } else {
            for (let objMobx of objValue) {
              newLevel[key] = this.recursiveDeepCopy(objMobx, level);
            }
          }
        } catch (err) {
          newLevel[key] = this.recursiveDeepCopy(objValue, level);
        }
      } else {
        // console.log('    Property (' + level + ') | Key:' + key + ' = ' + objValue)
        newLevel[key] = objValue;
      }
    }

    return newLevel;
  };

  static consoleToFile = (data, filename) => {
    if (!data) {
      console.error("Console.save: No data");
      return;
    }

    if (!filename) filename = "console.json";

    if (typeof data === "object") {
      let obj = this.recursiveDeepCopy(data);

      data = JSON.stringify(obj, undefined, 4);
    }

    var blob = new Blob([data], { type: "text/json" }),
      e = document.createEvent("MouseEvents"),
      a = document.createElement("a");

    a.download = filename;
    a.href = window.URL.createObjectURL(blob);
    a.dataset.downloadurl = ["text/json", a.download, a.href].join(":");
    e.initMouseEvent("click", true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
    a.dispatchEvent(e);
  };

  /* casting a data to the specific parameters
  {type:"string"} - convert to string
  {type:"boolean"} - convert to boolean
  {type:"number", format:""} - convert to number with specified format
  */
  static typecast = (data, casting) => {
    if (casting === undefined || casting.type === undefined) return data;
    var out = data;
    switch (casting.type) {
      case "string":
        out = String(data);
        break;
      case "boolean":
        out = Boolean(data);
        break;
      case "number":
        out = numeral(data).format(casting.format);
        break;
      default:
        break;
    }
    return out;
  };

  /* validate data with a list of parameters
  returns undefined in case of unvalidated value or right formatted value
  validations array consist of one or more items:
  {type:"notempty"} - must contain any value
  {type:"default", value:defaultValue} - if empty, fill with defalutValue. Must not use with "notempty"
  {type:"email"} - must contain email value
  {type:"emails"} - must contain email values, separated with comma
  {type:"minLength", value:minLength} - must be not less than minLength characters
  {type:"maxLength", value:maxLength} - must be not more than maxLength characters
  {type:"exactLength", value:exactLength} - must be exactly exactLength characters
  {type:"greater", value:greaterValue} - must be greater than greaterValue
  {type:"less", value:lessValue} - must be less than lessValue
  {type:"notGreater", value:greaterValue} - must be not greater than greaterValue
  {type:"notLess", value:lessValue} - must be not less than lessValue
  {type:"alpha"} - must be only alphabetic characters
  {type:"alphanumeric"} - must be only alphanumeric characters
  {type:"alphadash"} - must be only alphanumeric characters, dashes and underscores
  {type:"numeric"} -  must contain only numbers
  {type:"integer"} -  must contain only integer
  {type:"decimal"} -  must contain a decimal number
  {type:"natural"} -  must contain only positive numbers
  {type:"naturalNoZero"} -  must contain a number greater than zero
  {type:"time"} -  must contain valid hour and minute
  */

  static validate = (data, validations, casting) => {
    if (validations === undefined || validations.length === 0) return { value: data };
    var out = data;
    var errors = [];
    validations.forEach((validation) => {
      switch (validation.type) {
        case "notempty":
          if (data === null || data === undefined || data === "" || data == []) errors.push({ error: "notempty" });
          break;
        case "default":
          if (data === null || data === undefined || data === "" || data == []) out = validation.value;
          break;
        case "email":
          if (!emailRegex.test(data)) errors.push({ error: "email" });
          break;
        case "emails":
          var eml = false;
          var result = data.split(/\s*,\s*/g);
          for (var i = 0, resultLength = result.length; i < resultLength; i++) {
            if (!emailRegex.test(result[i])) eml = true;
          }
          if (eml) errors.push({ error: "email" });
          break;
        case "minLength":
          if (data.length < parseInt(validation.value, 10))
            errors.push({
              error: "minLength",
              value: parseInt(validation.value, 10),
            });
          break;
        case "maxLength":
          if (data.length > parseInt(validation.value, 10))
            errors.push({
              error: "maxLength",
              value: parseInt(validation.value, 10),
            });
          break;
        case "exactLength":
          if (data.length !== parseInt(validation.value, 10))
            errors.push({
              error: "exactLength",
              value: parseInt(validation.value, 10),
            });
          break;
        case "greater":
          if (!decimalRegex.test(data)) errors.push({ error: "numeric" });
          if (parseFloat(data) <= parseFloat(validation.value))
            errors.push({
              error: "greater",
              value: parseInt(validation.value, 10),
            });
          break;
        case "less":
          if (!decimalRegex.test(data)) errors.push({ error: "numeric" });
          if (parseFloat(data) >= parseFloat(validation.value))
            errors.push({
              error: "less",
              value: parseInt(validation.value, 10),
            });
          break;
        case "notGreater":
          if (!decimalRegex.test(data)) errors.push({ error: "numeric" });
          if (parseFloat(data) > parseFloat(validation.value))
            errors.push({
              error: "notGreater",
              value: parseInt(validation.value, 10),
            });
          break;
        case "notLess":
          if (!decimalRegex.test(data)) errors.push({ error: "numeric" });
          if (parseFloat(data) < parseFloat(validation.value))
            errors.push({
              error: "notLess",
              value: parseInt(validation.value, 10),
            });
          break;
        case "alpha":
          if (!alphaRegex.test(data)) errors.push({ error: "alpha" });
          break;
        case "alphadash":
          if (!alphaDashRegex.test(data)) errors.push({ error: "alphadash" });
          break;
        case "numeric":
          if (!numericRegex.test(data)) errors.push({ error: "numeric" });
          break;
        case "integer":
          if (!integerRegex.test(data)) errors.push({ error: "integer" });
          break;
        case "decimal":
          if (!decimalRegex.test(data)) errors.push({ error: "decimal" });
          break;
        case "natural":
          if (!naturalRegex.test(data)) errors.push({ error: "natural" });
          break;
        case "naturalNoZero":
          if (!naturalNoZeroRegex.test(data)) errors.push({ error: "naturalNoZero" });
          break;
        case "time":
          if (!timeRegex.test(data)) errors.push({ error: "time" });
          break;
        default:
          break;
      }
    });
    if (errors.length === 0) {
      if (casting) out = this.typecast(out, casting);
      return { value: out };
    } else {
      var error = errors.reduce((prev, curr, index, arr) => {
        if (prev.error === "notempty") return prev;
        if (prev.error === "numeric") return prev;
        return curr;
      });
      return { errors: [error] };
    }
  };

  static errorMessage = (error) => {
    var txt = "";
    switch (error.error) {
      case "notempty":
        txt = "Value expected";
        break;
      case "email":
        txt = "Wrong email format";
        break;
      case "numeric":
        txt = "Number expected";
        break;
      case "minLength":
        txt = `Value is must be not less than ${error.value} characters length`;
        break;
      case "maxLength":
        txt = `Value is must be not more than ${error.value} characters length`;
        break;
      case "exactLength":
        txt = `Value must be ${error.value} characters length`;
        break;
      case "greater":
        txt = `Value must be greater than ${error.value}`;
        break;
      case "less":
        txt = `Value must be less than ${error.value}`;
        break;
      case "notGreater":
        txt = `Value must be not greater than ${error.value}`;
        break;
      case "notLess":
        txt = `Value must be not less than ${error.value}`;
        break;
      case "alpha":
        txt = "Value must contain only alphabetic characters";
        break;
      case "alphanumeric":
        txt = "Value must contain only alphanumeric characters";
        break;
      case "alphadash":
        txt = "Value must contain only alphanumeric characters, dashes and underscores";
        break;
      case "integer":
        txt = "Value must be an integer";
        break;
      case "decimal":
        txt = "Value must be a decimal";
        break;
      case "natural":
        txt = "Value must be  only positive numbers or 0";
        break;
      case "naturalNoZero":
        txt = "Value must be  a number greater than zero";
        break;
      default:
        txt = "Unknown error";
    }
    return txt;
  };

  static getOS = () => {
    var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
      windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
      iosPlatforms = ["iPhone", "iPad", "iPod"],
      os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = "macOS";
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = "iOS";
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = "Windows";
    } else if (/Android/.test(userAgent)) {
      os = "Android";
    } else if (!os && /Linux/.test(platform)) {
      os = "Linux";
    }

    return os;
  };

  static timeStringToFloat = function (time) {
    if (time === undefined) {
      return 0;
    }

    var hoursMinutes = time.split(/[.:]/);
    var hours = parseInt(hoursMinutes[0], 10);
    var minutes = hoursMinutes[1] ? parseInt(hoursMinutes[1], 10) : 0;
    var total = hours + minutes / 60;
    return total;
  };

  static msToDateTime = function (timeMS) {
    if (timeMS === undefined) {
      return 0;
    }
    var time = dayjs(timeMS).format("HH:mm");
    return time;
  };

  static msDurationToDateTime = function (timeMS) {
    if (timeMS === undefined) {
      return 0;
    }
    var time = dayjs.utc(dayjs.duration(timeMS, "ms").asMilliseconds()).format("HH:mm");
    return time;
  };

  static msToDateTimeFull = function (timeMS) {
    if (timeMS === undefined) {
      return 0;
    }
    var time = dayjs(timeMS).format("LLLL");
    return time;
  };

  static msDurationHumanise = function (timeMS) {
    if (timeMS === undefined) {
      return 0;
    }
    var time = dayjs.duration(timeMS).humanize();
    return time;
  };

  static timeStringToHoursMin = function (timeString) {
    return dayjs(timeString).format("HH:mm");
  };

  static timeStringFull = function (timeString) {
    return dayjs(timeString).format("llll");
  };

  static stringToday = function () {
    return dayjs().format("YYYY-MM-DD");
  };

  static dateFormatStringSearch = function (date) {
    return dayjs(date).format("YYYY-MM-DD");
  };

  static dateFormatString = function (dateObject) {
    return dayjs(dateObject).format("dddd, D MMMM YYYY");
  };

  static minutesToTimeString = function (minutes) {
    var h = Math.floor(minutes / 60);
    var m = minutes % 60;
    h = h < 10 ? "0" + h : h;
    m = m < 10 ? "0" + m : m;
    return h + ":" + m;
  };

  static urlExists = (url) => {
    var http = new XMLHttpRequest();
    http.open("HEAD", url, false);
    http.send();
    if (http.status !== 404) return true;
    else {
      return false;
    }
  };

  static findDuplicates = (arr, key) => {
    let result = [];

    arr.sort(); //((a, b) => { a[key] - b[key] })

    for (var i = 0; i < arr.length - 1; i++) {
      if (arr[i + 1][key] === arr[i][key]) {
        result.push(arr[i]);
        console.log("Found Duplicate " + key + ": " + arr[i][key]);
      }
    }

    return result;
  };

  static splitResponse = (combinedResponse) => {
    //Method to get the contentType using the new APIs structure
    //response will start as following "data:application/pdf;base64,...."
    let splitResponse1 = combinedResponse.split(":"); //first pass will remove the "data:"
    // console.log('First Part'+splitResponse1[0])//"data"
    // console.log('Second Part'+splitResponse1[1])//"application/pdf;base64,...."

    let splitResponse2 = splitResponse1[1].split(";");
    // console.log('First Part'+splitResponse2[0])//"application/pdf"
    // console.log('Second Part'+splitResponse2[1])//"base64,...."

    let contentType = splitResponse2[0];

    let splitResponse3 = splitResponse2[1].split(",");
    // console.log('First Part'+splitResponse3[0])//"base64"
    // console.log('Second Part'+splitResponse3[1])//"...."

    let fileResponse = splitResponse3[1]; //this is file base64 that we need to use

    //return response will contain [contentType, base64 data]
    return [contentType, fileResponse];
  };

  //Started using blobs because there was an issue with files having their size over 2 MB not downloading
  static b64toBlob = (b64Data, contentType) => {
    contentType = contentType || "";
    var sliceSize = 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  static deepSearchByKey = (key, data, found = []) => {
    Object.keys(data).forEach((item) => {
      if (item === key) {
        found.push(data[item]);
        return found;
      }
      if (typeof data[item] === "object") {
        this.deepSearchByKey(key, data[item], found);
      }
    });
    return found;
  };

  static extractErrorMessage = (err) => {
    let error = {
      message: "An error has occurred",
      description: null,
      isDefault: true,
    };

    // This is a check to see if the error was a message returned from the API.
    if (err.response && err.response.data && err.response.data.message) {
      error.message = "API ERROR";
      error.description = err.response.data.message.toUpperCase();
      error.isDefault = false;
    }

    // Check different types of messages.
    if (error.isDefault && err.message) {
      // Check if the error message is an axios error (network related).
      if (err.isAxiosError && typeof err.message === "string") {
        error.message = "API ERROR";
        error.description = err.message.toUpperCase();
        error.isDefault = false;

        console.log("Axios Error Message: ", err.message);
      }
      // Otherwise check if the message is a string and display it. This will be a UI issue.
      else if (typeof err.message === "string") {
        error.message = "UI ERROR";
        error.description = err.message.toUpperCase();
        error.isDefault = false;

        console.log("UI Detailed Error Message: ", err.message);
      }
      // Last option is to log the error message as is of a different type that is not supported.
      else {
        console.log("Error Message: ", toJS(err));
      }
    }

    return error;
  };

  /**
   * Checks the routeRef to make sure it is in the correct format.
   * Should be 10 characters, and alphanumeric with no spaces.
   * Author : IFC
   */
  static checkRouteRef = (routeRef, charLimit = 10, mode = "alphanumeric") => {
    let regex = new RegExp(`^[a-zA-Z0-9\-_]{0,${charLimit}}$`, "gi");

    switch (mode) {
      case "alphanumeric":
        regex = new RegExp(`^[a-zA-Z0-9\-_]{0,${charLimit}}$`, "gi");
        break;
      case "numeric":
        regex = new RegExp(`^[0-9]{0,${charLimit}}$`, "gi");
        break;
      default:
        break;
    }

    // Returns false if it fails
    return regex.test(routeRef);
  };

  static checkRef = (ref) => {
    const regex = /^[a-zA-Z0-9\-_]{0,35}$/;

    // Returns false if it fails
    return regex.test(ref);
  };
}

export { common };
